/**
 * @license The MIT License (MIT)
 * @copyright Igor Zaporozhets <i.zaporozhets@infomir.com>
 */

'use strict';

var Component = require('stb-component'),
    keys      = require('stb-keys'),
    layouts   = require('./content.list.layouts');


/**
 * @param {Object} config configuration for list of some sort
 *
 * @constructor
 */
function ContentList ( config ) {
    var self = this;

    // for ( var p in config.provider.application ) {
    //     console.log(p);
    //     console.log(JSON.stringify(config.provider.application[p]))
    // }
    if ( config.provider.layout ) {
        config.className = 'content-list-' + config.provider.layout;
        config.listClass = config.provider.layout;
    }

    if (config.provider.packageName === 'magcore-plugin-backend-radio' || config.provider.packageName === 'magcore-plugin-backend-karaoke') {
        config.className = 'content-list-static-square';
        config.listClass = 'static-square';
    }

    self.$focusItem = null;
    self.viewIndex = null;

    /**
     * Component data to visualize.
     *
     * @type {Array}
     */
    self.data = [];
    this.disabledList = [];

    /**
     * Allow or not to jump to the opposite side of a list when there is nowhere to go next.
     *
     * @type {boolean}
     */
    self.cycle = false;

    self.dataToDOM = {};

    Component.call(self, config);

    this.addListener('focus', function () {
        setTimeout(function () {
            if ( self.$focusItem === null && self.$body.firstChild ) {
                self.focusItem(self.$body.firstChild);
            } else if ( self.$focusItem !== null ) {
                self.focusItem(self.$focusItem);
            }
        }, 0);
    });

    this.addListener('blur', function () {
        self.blurItem(self.$focusItem);
    });

    this.init(config);
}


// inheritance
ContentList.prototype = Object.create(Component.prototype);
ContentList.prototype.constructor = ContentList;

// set component name
ContentList.prototype.name = 'content-list';


ContentList.prototype.defaultEvents = {
    mousewheel: function ( event ) {
        this.parent.emit('mousewheel', event);
    },

    keydown: function ( event ) {
        var self = this,
            item;

        console.log('ContentList');

        if ( event.code === keys.left || event.code === keys.right ) {
            if ( self.move(event.code) ) {
                event.stop = true;
            }
        } else if ( event.code === keys.ok ) {
            // this.blurItem(this.$focusItem);
            item = this.data[this.$focusItem.tabIndex];

            if ( this.$focusItem.timeoutId ) {
                clearTimeout(this.$focusItem.timeoutId);
            }

            if ( item.onClick ) {
                this.data[this.$focusItem.tabIndex].onClick();
            } else if ( item.data.onClick ) {
                item.data.onClick();
            }
        }
    }
};


ContentList.prototype.renderView = function ( index ) {
    var self = this,
        $item, iteration, itemData;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) { throw new Error(__filename + ': wrong arguments number'); }
        if ( Number(index) !== index ) { throw new Error(__filename + ': index must be a number'); }
        if ( index < 0 ) { throw new Error(__filename + ': index should be more than zero'); }
    }

    // has the view window position changed
    if ( self.viewIndex !== index ) {
        self.viewIndex = index;

        // rebuild all visible items
        iteration = 0;
        while ( iteration < self.size ) {
            // shortcuts
            $item    = self.$body.children[iteration];
            itemData = self.data[index];
            if ( itemData ) {
                $item.tabIndex = index;
                itemData.render($item);
            } else {
                // nothing to render
                $item.className = 'hidden';
                $item.ready = false;
            }
            ++iteration;
            ++index;
        }
    }
};


ContentList.prototype.focusItem = function ( $item ) {
    var $prev = this.$focusItem;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) {
            throw new Error(__filename + ': wrong arguments number');
        }
    }

    if ( DEVELOP ) {
        if ( !($item instanceof Element) ) {
            throw new Error(__filename + ': wrong $item type');
        }
        if ( $item.parentNode !== this.$body ) {
            throw new Error(__filename + ': wrong $item parent element');
        }
    }

    if ( $prev !== null ) {
        // some item is focused already
        this.blurItem($prev);
    }

    this.$focusItem = $item;
    this.data[$item.tabIndex].focus($item);
    this.emit('focus:item', {$prev: $prev, $item: $item});
};


ContentList.prototype.blurItem = function ( $item ) {
    var self = this;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) {
            throw new Error(__filename + ': wrong arguments number');
        }
    }

    if ( $item ) {
        this.data[$item.tabIndex].blur($item);
        if ( self.events['blur:item'] ) {
            self.emit('blur:item', {$item: $item});
        }
    }
};


ContentList.prototype.move = function ( direction ) {
    var self = this,
        $item, $target;


    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) {
            throw new Error(__filename + ': wrong arguments number');
        }
        if ( Number(direction) !== direction ) {
            throw new Error(__filename + ': direction must be a number');
        }
    }

    // empty list
    if ( !self.data.length ) {
        return false;
    }

    switch ( direction ) {
        case keys.left:
            $target = self.$focusItem.previousSibling;

            if ( self.$focusItem && self.$focusItem.tabIndex > 0 ) {
                self.focusItem(self.$focusItem.previousSibling);
            } else {
                return false;
            }

            if ( this.disabledList.length ) {
                $item = this.disabledList.pop();
                $item.style.display = '';
            }

            // if ( self.$focusItem === self.$body.lastChild.previousSibling ) {
            //     self.$node.scrollLeft -= (self.$focusItem.offsetWidth * 0.75);
            // } else if ( (self.$node.scrollLeft) > 0 ) {
            //     self.$node.scrollLeft -= (self.$focusItem.offsetWidth);
            // }

            return true;

        case keys.right:
            $target = self.$focusItem.nextSibling;

            if ( self.$focusItem && self.$focusItem.tabIndex < self.data.length - 1 ) {
                self.focusItem(self.$focusItem.nextSibling);
            } else {
                return false;
            }

            if ( ($target.offsetWidth * $target.tabIndex) > (self.$node.offsetWidth / 2) ) {
                $item = this.$node.children[this.disabledList.length];
                this.disabledList.push($item);
                $item.style.display = 'none';
                // if ( self.$node.scrollLeft === 0 ) {
                //     self.$node.scrollLeft += ($target.offsetWidth * 1.25);
                // } else {
                //     self.$node.scrollLeft += $target.offsetWidth;
                // }
            }

            console.log('scrollLeft ' + self.$node.scrollLeft);

            return true;
    }

    return false;
};


function normalize ( data ) {
    var index = 0,
        item, layout;

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) { throw new Error(__filename + ': wrong arguments number'); }
        if ( !Array.isArray(data) ) { throw new Error(__filename + ': wrong data type'); }
    }

    // rows
    while ( index < data.length ) {
        // cell value
        item = data[index];
        // primitive value
        // console.log(item.layout);
        layout = layouts[item.layout];
        // console.log('item.geometry ' + item.geometry);
        // console.log('layout.geometry ' + layout[item.geometry]);
        // console.log(layout);
        if ( item.geometry && layout[item.geometry] ) {
            // console.log('geometry render ' + layout[item.geometry].render);
            layout = layout[item.geometry];
        }
        item.render = layout.render;
        item.focus = layout.focus;
        item.blur = layout.blur;
        ++index;
    }

    return data;
}


/**
 * Init or re-init of the component inner structures and HTML.
 *
 * @param {Object} config init parameters (subset of constructor config params)
 */
ContentList.prototype.init = function ( config ) {
    var self     = this,
        currSize = this.$body.children.length,
        /**
         * Item mouse click handler.
         *
         * @param {Event} event click event data
         *
         * @this Element
         *
         * @fires module:stb/ui/list~List#click:item
         */
        onClick = function ( event ) {
            if ( this.data ) {
                self.focusItem(this);

                // there are some listeners
                if ( self.events['click:item'] ) {
                    // notify listeners
                    self.emit('click:item', {$item: this, event: event});
                }
            }
        },
        $item, index;

    if ( config.data ) {
        if ( DEVELOP ) {
            if ( !Array.isArray(config.data) ) { throw new Error(__filename + ': wrong config.data type'); }
        }
        // prepare user data
        this.data = normalize(config.data);

        this.size = this.data.length;
    }

    if ( DEVELOP ) {
        if ( arguments.length !== 1 ) {
            throw new Error(__filename + ': wrong arguments number');
        }
        if ( typeof config !== 'object' ) {
            throw new Error(__filename + ': wrong config type');
        }
    }

    // apply cycle behaviour
    if ( config.cycle !== undefined ) {
        this.cycle = config.cycle;
    }

    // list items amount on page
    if ( config.size ) {
        if ( DEVELOP ) {
            if ( Number(config.size) !== config.size ) {
                throw new Error(__filename + ': config.size must be a number');
            }
            if ( config.size <= 0 ) {
                throw new Error(__filename + ': config.size should be positive');
            }
        }

        // apply
        this.size = config.size;
    }

    // geometry has changed or initial draw
    if ( this.size !== currSize ) {
        // non-empty list
        if ( currSize > 0 ) {
            // clear old items
            this.$body.innerText = null;
        }

        // create new items
        for ( index = 0; index < this.size; index++ ) {
            $item = document.createElement('div');
            $item.tabIndex = index;
            $item.addEventListener('click', onClick);
            this.$body.appendChild($item);

            if ( this.data[index].id ) {
                this.dataToDOM[this.data[index].id] = $item;
            }
        }
    }

    // set focus item
    // if ( config.focusIndex !== undefined && this.data.length ) {
    //     if ( DEVELOP ) {
    //         if ( Number(config.focusIndex) !== config.focusIndex ) { throw new Error(__filename + ': config.focusIndex must be a number'); }
    //         if ( config.focusIndex < 0 ) { throw new Error(__filename + ': config.focusIndex should be positive'); }
    //     }

    //     // jump to the necessary item
    //     this.focusIndex(config.focusIndex);
    // }
    this.renderView(0);
    // setTimeout(function () {
    //     // hack for list scroll to center
    //     var $space = self.$node.appendChild(document.createElement('div'));

    //     $space.style.width = (2 * self.$node.children[0].offsetWidth) + 'px';
    //     $space.style.height = self.$node.children[0].offsetHeight + 'px';
    //     $space.style.display = window.getComputedStyle(self.$node.firstChild).display;

    //     $space = self.$node.appendChild(document.createElement('div'));

    //     $space.style.width = (2 * self.$node.children[0].offsetWidth) + 'px';
    //     $space.style.height = self.$node.children[0].offsetHeight + 'px';
    //     $space.style.display = window.getComputedStyle(self.$node.firstChild).display;
    // }, 0);
    this.$focusItem = self.$body.children[0];
};

/**
 * Set the given item focused by item index.
 *
 * @param {number} index item data index
 */
ContentList.prototype.focusIndex = function ( index ) {
    var viewIndex = this.viewIndex || 0;

    if ( DEVELOP ) {
        if ( Number(index) !== index ) { throw new Error(__filename + ': index must be a number'); }
        if ( index < 0 ) { throw new Error(__filename + ': index should be positive'); }
    }

    // determine direction
    if ( index >= viewIndex + this.size ) {
        // check range
        index = index < this.data.length - 1 ? index : this.data.length - 1;
        // move down
        this.renderView(index - this.size + 1);
        this.focusItem(this.$body.lastChild);
    } else if ( index < viewIndex ) {
        // check range
        index = index > 0 ? index : 0;
        // move up
        this.renderView(index);
        this.focusItem(this.$body.firstChild);
    } else {
        // no move
        if ( this.viewIndex === null ) {
            // first attempt
            this.renderView(0);
        }
        this.focusItem(this.$body.children[index - viewIndex]);
    }
};


/**
 * Add content item card dynamically in runtime.
 *
 * @param {Object} item item to add in the list
 */
ContentList.prototype.addContentItem = function ( item ) {
    var self  = this,
        $item = document.createElement('div'),
        /**
         * Item mouse click handler.
         *
         * @param {Event} event click event data
         *
         * @this Element
         *
         * @fires module:stb/ui/list~List#click:item
         */
        onClick = function ( event ) {
            if ( this.data ) {
                self.focusItem(this);

                // there are some listeners
                if ( self.events['click:item'] ) {
                    // notify listeners
                    self.emit('click:item', {$item: this, event: event});
                }
            }
        },
        index;

    this.dataToDOM[item.id] = $item;

    item = normalize([item])[0];
    $item.addEventListener('click', onClick);

    if ( item.index === undefined ) {
        this.data.splice(this.size - 2, 0, item);
        this.$body.insertBefore($item, this.$body.children[this.size - 2]);
    } else {
        this.data.splice(item.index, 0, item);
        this.$body.insertBefore($item, this.$body.children[item.index]);
    }

    this.size += 1;

    for ( index = 0; index < this.size; index += 1 ) {
        this.$body.children[index].tabIndex = index;
    }

    item.render($item);
};


/**
 * Remove content item card dynamically in runtime.
 *
 * @param {Object} item item to remove from the list
 */
ContentList.prototype.removeContentItem = function ( item ) {
    var $focused    = this.$focusItem,
        $parentNode = $focused.parentNode,
        index;

    if ( this.dataToDOM[item.id] ) {
        this.$body.removeChild(this.dataToDOM[item.id]);
        delete this.dataToDOM[item.id];
    }

    this.size -= 1;
    this.data.splice(this.data.indexOf(item), 1);

    for ( index = 0; index < this.size; index += 1 ) {
        this.$body.children[index].tabIndex = index;
    }

    if ( $parentNode.classList.contains('focus') ) {
        this.focusIndex($focused.tabIndex);
    }
};


module.exports = ContentList;
